import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import NavigationButtons from './navigationButtons'
// import * as actions from '../../../../store/associadoPJReducer/navegationSteps/actions'

// const mapDispatchToProps = dispatch =>
//   bindActionCreators(actions, dispatch)

export default connect(
  // mapDispatchToProps
)(NavigationButtons);
